import React, { useState } from "react";

// components
import { Link } from "react-router-dom";
import { Button } from "../_commons/Button";
import { SearchFilter } from "../_commons/SearchFilter";

//third party

// assets
import CreateIcon from "../_commons/CreateIcon";

export const Header = (props) => {
	return (
		<div className="credits-section-header transactions-list-header">
			<div className="header-text">
				<div className="title">Meraki Coupons</div>
				<div className="subtitle">Central repository for all your coupons</div>
			</div>
			<div className="header-action-button">
				<div className="filter-buttons">
					{props.dimensions.width > 768 && (
						<div
							className={(props.filterActive ? "active" : "") + " filter-in-header campaign-list-filter"}
						>
							<div className="container" onClick={props.flipShowFilters}>
								<img className="filter-icon" src="/assets/icons/icon-sorting-options.svg" alt="" />
								<div className="filter-title">
									Filter
									{props.filterCount > 0 && <span className="filter-count">{props.filterCount}</span>}
								</div>
							</div>
						</div>
					)}
					<div className="action-buttons-container">
						<Link to="/coupons/new">
							<Button>
								<CreateIcon />
								<span>Add Coupon</span>
							</Button>
						</Link>
					</div>
					{props.dimensions.width > 768 && (
						<SearchFilter
							filterOption={props.filterOption}
							value={props.value}
							setFilter={props.setFilter}
							placeholder="Search by name"
						/>
					)}
				</div>
			</div>
		</div>
	);
};
